/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEye,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Modal, Button } from 'react-bootstrap';
import Tooltip from "@mui/material/Tooltip";
import { withTranslation } from "react-i18next";
import { jsPDF } from "jspdf";
import { AllTransferStationTransactions } from "../../Apis/TransferStationReport/allTransferStationTransactionApi";
import { AllSecondaryCollectionTransaction } from "../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
// import QRCode from "react-qr-code";
import QRCode from 'qrcode-svg';

import { useNavigate } from "react-router-dom";
import { GetCircle } from "../../Apis/organizationApi";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import isGHMC from "../../Common/helper/helpar";
import CloseIcon from '@material-ui/icons/Close';

const TableComponent = ({
  DataFetchURL,
  editData,
  headers,
  viewData,
  t,
  footerCount,
  fromDate,
  toDate,
  date,
  pdf,
  link,
  search,
  select,
  circle,
  gvpClearence,
  onSort,
  props,
  qrDownloadButton,
  canEdit,
  hasTotalRow,
  skipGetCircle
}) => {
  const rowsPerPage = 100;
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ column: null, order: "asc" });
  const [totalPagesCount, setTotalPagesCount] = useState(1);
  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [totals, setTotals] = useState({});
  const [totalSum, setTotalSum] = useState(0);
  const [tSSCTPTTRData, setTSSCTPTTRData] = useState([]);
  const [downloadQRCode, setDownloadQRCode] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedVehicleUUID, setSelectedVehicleUUID] = useState(null);
  const [selectedContainerUUID, setSelectedContainerUUID] = useState(null);
  const [selectedLoadingEquipmentUUID, setSelectedLoadingEquipmentUUID] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [qrData, setQrData] = useState("");
  const [zoneData, setZoneData] = useState([]);
  const [qrDataArray, setQrDataArray] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState();
  const isProd = isGHMC();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const filterFunction = (data) => {
    return data
      .filter((item) => {
        // Accept numeric status codes (1/2), string labels, or boolean isActive
        if (item == null) return false;
        if (typeof item.status === 'number') {
          return item.status === 1 || item.status === 2;
        }
        if (typeof item.status === 'string') {
          const s = item.status.toLowerCase();
          return s === 'active' || s === 'inactive';
        }
        if (typeof item.isActive === 'boolean') {
          return true; // include items with explicit isActive boolean
        }
        return false;
      })
      .map((item) => ({
        ...item,
        shiftA: item.shiftA ? '✔️' : '❌', // Display tick for true, cross for false
        shiftB: item.shiftB ? '✔️' : '❌',
        shiftC: item.shiftC ? '✔️' : '❌',
      }));
  };

  // Function to handle image click
  const handleImageClick = (imageUrl) => {
    console.log(imageUrl)
    setSelectedImage(imageUrl);
    setShow(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setShow(false);
    setSelectedImage(null);
  };

  const handleDownloadQRCode = (rowData) => {
    setSelectedData(rowData);
    setDownloadQRCode(true);
    setSelectedRowData(rowData);
    setSelectedVehicleUUID(rowData.vehicleUuid);
    setSelectedLoadingEquipmentUUID(rowData.loadingEquipmentUid);
    setSelectedContainerUUID(rowData.containerUuid);
    setShowModal(true);
    // Push QR code data to the array
    let qrCodeDataArray = [];
    if (selectedVehicleUUID) {
      qrCodeDataArray.push(selectedVehicleUUID);
    } else if (selectedContainerUUID) {
      qrCodeDataArray.push(selectedContainerUUID);
    } else if (selectedLoadingEquipmentUUID) {
      qrCodeDataArray.push(selectedLoadingEquipmentUUID);
    }
    setQrDataArray(qrCodeDataArray);
  };

  useEffect(() => {
    if (
      showModal &&
      (selectedVehicleUUID || selectedContainerUUID || selectedLoadingEquipmentUUID) &&
      selectedRowData
    ) {
      let qrCodeData = "";
      if (selectedVehicleUUID) {
        qrCodeData =
          // `Vehicle Number: ${selectedRowData.vehicleNumber || ""}\n` +
          //   `Vehicle Type: ${selectedRowData.vehicleType || ""}\n` +
          //   `Zone: ${selectedRowData.zone || ""}\n` +
          //   `Circle: ${selectedRowData.circle || ""}`+
          selectedVehicleUUID || "";
      } else if (selectedContainerUUID) {
        qrCodeData =
          // `Container Code: ${selectedRowData.containerCode || ""}\n` +
          selectedContainerUUID || "";
        //  +
        // `Container Type: ${selectedRowData.containerType || ""}\n` +
        // `Container Name: ${selectedRowData.containerName || ""}\n` +
        // `Vehicle Status: ${selectedRowData.vehicleStatus || ""}`;
      } else if (selectedLoadingEquipmentUUID) {
        qrCodeData =
          // `Container Code: ${selectedRowData.containerCode || ""}\n` +
          selectedLoadingEquipmentUUID || "";
        //  +
        // `Container Type: ${selectedRowData.containerType || ""}\n` +
        // `Container Name: ${selectedRowData.containerName || ""}\n` +
        // `Vehicle Status: ${selectedRowData.vehicleStatus || ""}`;
      }
      // Set the QR code data to the state variable
      setQrData(qrCodeData);
    }
  }, [showModal, selectedVehicleUUID, selectedContainerUUID, selectedLoadingEquipmentUUID, selectedRowData]);




  const downloadQRCodeImage = () => {
    try {
      const uuid = selectedVehicleUUID || selectedContainerUUID || selectedLoadingEquipmentUUID;
      console.log("Processed UUID for QR Code:", uuid, "Type:", typeof uuid);

      const qr = new QRCode({
        content: qrData,
        padding: 4,
        width: 256,
        height: 256,
        color: "#000000",
        background: "#ffffff",
        ecl: "M",
      });

      const svg = qr.svg();
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      img.onload = () => {
        canvas.width = 256;
        canvas.height = 256;
        ctx.drawImage(img, 0, 0, 256, 256);

        const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("p", "mm", "a4");
        pdf.setFont("helvetica", "bold");

        const scaleFactor = 0.5;
        const scaledWidth = 256 * scaleFactor;
        const scaledHeight = 256 * scaleFactor;

        const initialX = (pdf.internal.pageSize.getWidth() - scaledWidth) / 2;
        const initialY = 10;

        // Add image to PDF
        pdf.addImage(imgData, "JPEG", initialX, initialY, scaledWidth, scaledHeight);

        // Determine labels and values based on item type
        let labels = [];
        let values = [];

        if (selectedRowData && selectedVehicleUUID) {
          labels = [
            "OWNER TYPE",
            "VEHICLE TYPE",
            "VEH. REG. NO",
            "VEHICLE CAPACITY",
            "ZONE",
            "CIRCLE",
            "UID",
          ];
          values = [
            selectedRowData.ownerTypeName,
            selectedRowData.vehicleTypeName,
            selectedRowData.vehicleNumber,
            selectedRowData.vehicleCapacityName,
            selectedRowData.zoneName,
            selectedRowData.circleName,
            selectedRowData.vehicleUuid,
          ];
        } else if (selectedRowData && selectedContainerUUID) {
          labels = [
            "EQUIPMENT ID",
            "EQUIPMENT TYPE",
            "EQUIPMENT CAPACITY",
            "EQUIPMENT MAKE",
            "EQUIPMENT UID",
          ];
          values = [
            selectedRowData.containerCode,
            selectedRowData.containerType,
            selectedRowData.containerCapacityName,
            selectedRowData.containerName,
            selectedRowData.containerUuid,
          ];
        } else if (selectedRowData && selectedLoadingEquipmentUUID) {
          labels = [
            "OWNER TYPE",
            "VEHICLE TYPE",
            "LOADING EQUIPMENT.NO",
            "VEHICLE STATUS",
            "ZONE",
            "CIRCLE",
            "UID",
          ];
          values = [
            selectedRowData.ownerTypeName,
            selectedRowData.vehicleTypeName,
            selectedRowData.loadingEquipmentNumber,
            selectedRowData.vehicleStatusName,
            selectedRowData.zoneName,
            selectedRowData.circleName,
            selectedRowData.loadingEquipmentUid,
          ];
        }

        let maxLabelWidth = 0;
        labels.forEach(label => {
          const labelWidth = pdf.getTextWidth(label);
          if (labelWidth > maxLabelWidth) {
            maxLabelWidth = labelWidth;
          }
        });

        const lineHeight = 7;
        const textX = 50; // Center align text with page width
        let textY = initialY + scaledHeight + 10; // Start below the QR code with some margin

        // Draw the labels and values with aligned colons
        pdf.setFont("arial", "normal");
        labels.forEach((label, i) => {
          pdf.text(label, textX, textY);
          pdf.text(": ", textX + maxLabelWidth + 1, textY);
          pdf.text(values[i] || "-", textX + maxLabelWidth + 5, textY);
          textY += lineHeight;
        });

        // Generate PDF and initiate download
        pdf.save(`qr-code-${uuid}.pdf`);
      };

      img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    } catch (error) {
      console.error("Error generating QR code:", error);
    }
  };
  // Call the function to initiate the download process
  // downloadQRCodeImage();


  // Call the function to initiate the download process
  // downloadQRCodePDF();




  //  // Generate QR code preview as SVG string
  const generateQRCodeSVG = () => {
    try {

      const qr = new QRCode({
        content: qrData,
        // padding: 4,
        width: 400,
        height: 400,
        color: "#000000",
        // background: "#ffffff",
        // ecl: "M",
      });
      return qr.svg();
    } catch (error) {
      console.error("Error generating QR code:", error);
      return "<svg></svg>"; // Return an empty SVG in case of error
    }
  };

  const handleMapClick = (location) => {
    setSelectedLocation(location);
    setShowMapModal(true);
  };

  useEffect(() => {
    if (DataFetchURL && DataFetchURL.length > 0) {
      const calculatedTotalPages = Math.ceil(DataFetchURL.length / rowsPerPage);
      setTotalPagesCount(calculatedTotalPages);
      setCurrentPage(1);
    }
  }, [DataFetchURL, rowsPerPage]);


  useEffect(() => {
    if (filteredData && Array.isArray(filteredData)) {
      // Calculate the total sum of rows
      let sum = 0;
      filteredData.forEach((item) => {
        headers.forEach((header) => {
          if (typeof item[header] === "number") {
            sum += item[header];
          }
        });
      });
      setTotalSum(sum);
    }
  }, [filteredData, headers]);

  const calculateRowTotal = (row) => {
    let total = 0;

    headers.forEach((header) => {
      if (typeof row[header] === "number") {
        total += row[header];
      }
    });

    return total;
  };

  // Inside your component's JSX, after the mapping of table rows
  filteredData.map(
    (item, index) => console.log()
    // console.log(`Row ${index + 1} Total:`, calculateRowTotal(item))
    // Rest of your code for mapping the table rows...
  );
  useEffect(() => {
    if (!Array.isArray(DataFetchURL)) {
      console.error("DataFetchURL is not an array");
      return;
    }

    let filtered = DataFetchURL?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        return String(item[key])
          .toLowerCase()
          .includes(String(value).toLowerCase());
      });
    });

    if (sortConfig.column) {
      filtered = filtered.sort((a, b) => {
        const valueA = String(a[sortConfig.column]);
        const valueB = String(b[sortConfig.column]);

        if (valueA && valueB) {
          return sortConfig.order === "asc"
            ? valueA.localeCompare(valueB, undefined, {
              numeric: true,
              sensitivity: "base",
            })
            : valueB.localeCompare(valueA, undefined, {
              numeric: true,
              sensitivity: "base",
            });
        } else {
          return 0;
        }
      });
    }

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const slicedData = filtered.slice(startIndex, endIndex);
    setFilteredData(slicedData);

    // Compute totals for each column
    const computeTotals = () => {
      const columnTotals = {};
      headers.forEach((header) => {
        const total = slicedData.reduce(
          (total, item) => total + parseFloat(item[header] || 0),
          0
        );
        // Check if the total is NaN, if yes, set it to an empty string
        columnTotals[header] = isNaN(total) ? "" : total;
      });
      setTotals(columnTotals);
    };
    computeTotals();
  }, [DataFetchURL, filters, sortConfig, currentPage, rowsPerPage, headers]);

  const formatTimeTo12Hour = (time) => {
    if (!time) {
      return "";
    }

    const [hours, minutes] = time.split(":");

    if (!hours || !minutes) {
      return "";
    }

    const parsedHours = parseInt(hours, 10);
    const period = parsedHours >= 12 ? "PM" : "AM";
    const formattedHours = parsedHours % 12 || 12;
    return `${formattedHours}:${minutes || "00"} ${period}`;
  };

  // const handleSort = (columnName) => {
  //   setSortConfig((prevConfig) => ({
  //     column: columnName,
  //     order:
  //       prevConfig.column === columnName && prevConfig.order === "asc"
  //         ? "desc"
  //         : "asc",
  //   }));
  // };
  const handleSort = (columnName) => {
    const order = sortConfig.column === columnName && sortConfig.order === 'asc' ? 'desc' : 'asc';
    setSortConfig({ column: columnName, order });
    if (onSort) {
      onSort({ column: columnName, order }); // Notify parent about sort changes
    }
  };
  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.column) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.column] < b[sortConfig.column]) {
          return sortConfig.order === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.column] > b[sortConfig.column]) {
          return sortConfig.order === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig]);

  const handleEdit = (row) => {
    if (editData) {
      editData(row);
    }
  };

  const convertToHeaderFormat = (key) => {
    if (key === "qrCode") return "QR Code";
    if (key === "vehicleUid") return <span title="Vehicle Unique Identification">Vehicle UID</span>;
    if (key === "containerUid") return <span title="Container Unique Identification">Container UID</span>;
    if (key === "hookloaderUid") return <span title="Hookloader Unique Identification">Hookloader UID</span>;
    if (key === "tsname") return <span title="Transfer Station Name">TS Name</span>;
    if (key === "tsincharge") return <span title="Transfer Station Incharge">TS Incharge</span>;
    if (key === "sdincharge") return <span title="Secondary Deployment Incharge">SD Incharge</span>;
    if (key === "pdincharge") return <span title="Primary Deployment Incharge">PD Incharge</span>;
    if (key === "pnDPlantInhouseTime") return <span title="Processing and Disposal Plant Inhouse Time">pnD Plant Inhouse Time</span>;
    if (key === "firstgvpstarttime") return <span title="First Garbage Vulnerable Point Start Time">First GVP Start Time</span>;
    if (key === "lastgvpendtime") return <span title="Last Garbage Vulnerable Point End Time">Last GVP End Time</span>;
    if (key === "totaldeducationhourspqr") return <span title="Total Deduction Hours">Total Deduction Hours</span>;
    if (key === "loadingEquipmentUid") return <span title="Loading Equipment Unique Identification">Loading Equipment UID</span>;
    if (typeof key !== "string") return "";
    const formattedKey = key.replace(/([A-Z])/g, " $1").trim();
    return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
  };
  const handlePageChange = (page) => {
    const newPage = Math.max(1, Math.min(page, totalPagesCount));
    setCurrentPage(newPage);
  };

  const getzoneByCircleId = async () => {
    try {
      const zoneResponse = await GetCircle();
      setZoneData(zoneResponse);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    localStorage.removeItem("selected")
    localStorage.removeItem("checked")
    if (!skipGetCircle) {
      getzoneByCircleId();
    }
  }, [skipGetCircle]);

  const handleTSSCTPTT = async (zoneId, circleId) => {
    // Store the selected zone ID in local storage
    localStorage.setItem("zoneId", zoneId);
    const selectedCircle = zoneData.find(
      (circle) => circle.circleId === circleId
    );
    try {
      // Call the GetCircle API to retrieve information about the selected circle

      // Proceed with your logic using the zone ID
      const startTime = "00:00";
      const endTime = "23:59";

      // Concatenate start and end times with the date
      const startDate = `${date}T${startTime}`;
      const endDate = `${date}T${endTime}`;

      if (select) {
        // Call the AllSecondaryCollectionTransaction API here with appropriate conditions
        let response;
        if (selectedCircle) {
          const zoneIds = selectedCircle.zoneId;

          if (circle) {
            response = await AllSecondaryCollectionTransaction(
              startDate,
              endDate,
              zoneIds,
              circleId
            );
          }
        } else {
          response = await AllSecondaryCollectionTransaction(
            startDate,
            endDate,
            zoneId,
            ""
          );
        }
        const responseData1 = response.data || [];
        if (gvpClearence) {
          navigate("/view-gvp-clearence", { state: responseData1 });
        } else {
          navigate("/view-scvs-circle-report", { state: responseData1 });
        }
        // Handle the response as needed
      } else {
        // Call the AllTransferStationTransactions API
        const response = await AllTransferStationTransactions(
          fromDate,
          toDate,
          2,
          zoneId
        );
        const responseData = response.data || [];
        setTSSCTPTTRData(responseData);
        navigate("/deployed-trips-tssctp", { state: responseData });
      }
    } catch (error) {
      console.error("Error fetching TSSCTP data:", error);
    }
  };





  const [selectedItems, setSelectedItems] = useState([]);

  // const handleCheckboxChange = (e) => {
  //   const isChecked = e.target.checked;
  //   localStorage.setItem("checked", isChecked);
  //  console.log(isChecked);
  //   // Update all items with isChecked status
  //   const newData = (isChecked === true ?DataFetchURL:filteredData).map((item) => ({
  //     ...item,
  //     isSelected: isChecked,
  //   }));

  //   setFilteredData(newData);
  //   setSelectAllChecked(isChecked);
  //   localStorage.setItem("selected", JSON.stringify(newData));
  // };

  useEffect(() => {
    try {
      localStorage.setItem("selected", JSON.stringify(DataFetchURL));
    } catch (e) {
      if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
        // Handle quota exceeded error
        console.warn('LocalStorage quota exceeded. Consider clearing some items.');
      } else {
        throw e;
      }
    }
  }, [DataFetchURL]);
  

  const handleCheckboxChangeSingle = (itemId) => {
    // Update the isSelected property of the clicked item
    const updatedData = filteredData.map((item) =>
      item.containerId === itemId || item.vehicleId === itemId || item.loadingEquipmentId === itemId
        ? { ...item, isSelected: !item.isSelected }
        : item
    );

    setFilteredData(updatedData);

    // Find the updated item with the matching itemId
    const selectedItem = updatedData.find(
      (item) => item.containerId === itemId || item.vehicleId === itemId || item.loadingEquipmentId === itemId
    );

    // Update selectedItems array based on the isSelected property
    const updatedSelectedItems = selectedItem.isSelected
      ? [...selectedItems, selectedItem] // Add the selected item
      : selectedItems.filter(
        (item) =>
          item.vehicleId !== itemId && item.containerId !== itemId && item.loadingEquipmentId !== itemId
      ); // Remove the unselected item

    setSelectedItems(updatedSelectedItems);

    // Update localStorage for selected items
    const selectedItemsToStore = updatedData.filter((item) => item.isSelected);
  
    // localStorage.setItem("selected", JSON.stringify(selectedItemsToStore));
  };

  localStorage.setItem("selectedItems", JSON.stringify(selectedItems));
  const checkedValue = localStorage.getItem("checked")



  //const checkedValue=localStorage.getItem("checked")

  const maxPageNumbersToShow = 5;

  const generatePageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    let endPage = Math.min(totalPagesCount, startPage + maxPageNumbersToShow - 1);

    // Adjust start and end if they are out of bounds
    if (endPage - startPage < maxPageNumbersToShow - 1) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div style={{ height: "auto", overflow: "hidden", position: "relative" }}>
      <div
        style={{ height: "100%", boxSizing: "content-box" }}
        onWheel={(e) => {
          const container = e.currentTarget;
          container.scrollTop += e.deltaY;
        }}
        className={hasTotalRow ? "hasTotalRow1" : ""}
      >
        <div 
          className="table-container"
          style={{maxHeight: 500}}
        >
          <table
            id="project-reports"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "10px",
              tableLayout: "auto",
              wordWrap: "break-word",
            }}
            className="table table-bordered table-hover text-center"
          >
            <thead className="position-sticky top-0">
              <tr>
                <th style={{
                  border: "1px solid #ddd",
                  textAlign: "center !important",
                  backgroundColor: isProd ? "#0d5da5" : "#EC1117",
                  width: '15px',
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
                >
                  {t("S.No")}
                </th>
                {headers.map((header, index) =>
                  header === "qrCode" ? (
                    <th
                      key={header}
                      style={{
                        border: "1px solid #ddd",
                        textAlign: "center",
                        backgroundColor: isProd ? "#0d5da5" : "#EC1117",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", flexDirection: "row", gap: "5px" }}>
                        <span style={{ wordBreak: "break-word" }}>{convertToHeaderFormat(header)}</span>
                      </div>
                    </th>
                  ) : (
                    <th key={index}
                      style={{
                        border: "1px solid #ddd",
                        textAlign: "center",
                        backgroundColor: isProd ? "#0d5da5" : "#EC1117",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      onClick={() => handleSort(header)}
                    >
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                        <span style={{ wordBreak: "break-word" }}>{convertToHeaderFormat(header)}</span>
                        {sortConfig.column === header && sortConfig.order && (
                          <span>
                            {sortConfig.order === "asc" ? " 🔼" : " 🔽"}
                          </span>
                        )}
                      </div>
                    </th>
                  )
                )}
                {/* {canEdit && ( // Conditionally render Edit column based on canEdit permission */}
                {/* <th
                    style={{
                      border: "1px solid #ddd",
                      textAlign: "justify",
                      backgroundColor: "#EC1117",
                    }}
                  >
                    <span>Edit</span>
                  </th> */}
                {/* // )} */}
              </tr>
            </thead>

            <tbody>

              {sortedData &&
                Array.isArray(sortedData) &&
                sortedData.length > 0 ? (
                sortedData.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <tr className={totalPagesCount == currentPage ? "last-row" : "" }>
                      <td
                        style={{
                          border: "1px solid #FFFFFF",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          backgroundColor:
                            isProd
                              ? index % 2 === 0
                                ? "#8fc9ff"
                                : "#aed8ff"
                              : index % 2 === 0
                                ? "#F8CCCD"
                                : "rgb(255, 237, 238)",
                        }}
                      >
                        {/* {index + 1} */}
                        <span>
                          {(currentPage - 1) * rowsPerPage + index + 1}
                        </span>
                      </td>

                      {headers.map((header) =>

                        header === "shiftA" || header === "shiftB" || header === "shiftC" ? (
                          <td
                            key={header}
                            style={{
                              border: "1px solid #FFFFFF",
                              padding: "8px",
                              textAlign: "center",
                              backgroundColor:
                                isProd
                                  ? index % 2 === 0
                                    ? "rgb(143, 201, 255)"
                                    : "rgb(174 216 255)"
                                  : index % 2 === 0
                                    ? "#F8CCCD"
                                    : "rgb(255 237 238)",
                            }}
                          >
                            {item[header] ? "✔️" : "❌"}
                          </td>
                        ) : header === "isOpenCollection" ||
                          header === "isTertiaryTransaction" ||
                          header === "isDeviatedFromTransferStation" ? (
                          <td
                            key={header}
                            style={{
                              border: "1px solid #FFFFFF",
                              padding: "8px",
                              textAlign: "center",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              backgroundColor:
                                isProd
                                  ? index % 2 === 0
                                    ? "#8fc9ff"
                                    : "#aed8ff"
                                  : index % 2 === 0
                                    ? "#F8CCCD"
                                    : "rgb(255 237 238)",
                            }}
                          >
                            {item[header] ? "True" : "False"}
                          </td>
                        ) : header === "address" || header === "beforeAddress" || header === "afterAddress" ? (
                        <td
                          key={header}
                          style={{
                            border: "1px solid #FFFFFF",
                            padding: "8px",
                            textAlign: "center",
                            minWidth: 300,
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            backgroundColor:
                              isProd
                                ? index % 2 === 0
                                  ? "#8fc9ff"
                                  : "#aed8ff"
                                : index % 2 === 0
                                  ? "#F8CCCD"
                                  : "rgb(255 237 238)",
                          }}
                        >
                          <span style={{maxWidth: "100%", display: "block", wordBreak: "break-word"}}>
                            {item[header]}
                          </span>
                        </td>
                        ) : (
                          header !== t("actions") &&
                          header !== "points" &&
                          header !== "total" && (
                            <td
                              key={header}
                              style={{
                                border: "1px solid #FFFFFF",
                                textAlign: "center",
                                backgroundColor:
                                  isProd
                                    ? index % 2 === 0
                                      ? "#8fc9ff"
                                      : "#aed8ff"
                                    : index % 2 === 0
                                      ? "#F8CCCD"
                                      : "rgb(255 237 238)",
                                color: link ? "blue" : "inherit", // Apply blue color if link is true
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                minWidth: (header === "category" || header === "leType") ? 160 : undefined,
                              }}
                            >
                              {header === "startTime" ||
                                header === "endTime" ? (
                                formatTimeTo12Hour(item[header])
                              ) : header === "isActive" || header === "status" ? (
                                (() => {
                                  let active = false;
                                  if (typeof item.isActive === 'boolean') {
                                    active = item.isActive;
                                  } else if (typeof item.status === 'number') {
                                    active = item.status === 1;
                                  } else if (typeof item.status === 'string') {
                                    active = item.status.toLowerCase() === 'active';
                                  }
                                  return active ? 'Active' : 'Inactive';
                                })()
                              ) : header === "isSupervisor" ? (
                                item[header] ? (
                                  "true"
                                ) : (
                                  "false"
                                )
                              ) : // Inside the table rendering logic
                                header === "image" ? (
                                  <img
                                    style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: '10px' }}
                                    src={item[header]}
                                    onClick={() => handleImageClick(item[header])}
                                    alt="Vehicle Image"
                                  />
                                ) : header === "beforeImage" ? (
                                  <img
                                    style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: '10px', display: item[header] || item.beforeimgField ? "block" : "none" }}
                                    src={item[header] || item.beforeimgField}
                                    onClick={() => handleImageClick(item.beforeImage)}
                                    alt="Before Image"
                                  />
                                ) : header === "afterImage" ? (
                                  <img
                                    style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: '10px', display: item[header] || item.afterimgField ? "block" : "none"}}
                                    src={item[header] || item.afterimgField}
                                    onClick={() => handleImageClick(item.afterImage)}
                                    alt="After Image"
                                  />
                                ) : header === "deployment_location_id" ? (
                                  <ul>
                                    {item[header].map((location) => (
                                      <li key={location.id}>
                                        {location.location_name}
                                      </li>
                                    ))}
                                  </ul>
                                ) : header === "collection_points_data" ? (
                                  <ul>
                                    {item[header].map((point) => (
                                      <li key={point.id}>
                                        <p style={{ textAlign: "start" }}>
                                          Collection Point:{" "}
                                          {point.collection_point_name}
                                        </p>
                                        <p style={{ textAlign: "end" }}>
                                          Sort Order: {point.sort_order}
                                        </p>
                                      </li>
                                    ))}
                                  </ul>
                                ) : header === "location" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      flexDirection: "row",
                                      gap: "5px",
                                    }}
                                  >
                                    <span style={{ wordBreak: "break-word" }}>{item[header]}</span>
                                    <FontAwesomeIcon
                                      icon={faMapMarkerAlt}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexShrink: 0,
                                      }}
                                      onClick={() => handleMapClick(item)}
                                    />
                                  </div>
                                ) : header === "qrCode" ? (
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      color: "blue", // Apply blue color if link is true
                                      display: "flex", // Changed to flex for better wrapping
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      flexDirection: "row",
                                      gap: "10px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={item.isSelected}
                                       className={item.isSelected ? "blue" : "black"}
                                      onChange={() => handleCheckboxChangeSingle(item.vehicleId || item.containerId || item.loadingEquipmentId)}
                                      // Handle checkbox change event here
                                      // Example: onChange={(e) => handleCheckboxChange(e, item.id)}
                                      style={{
                                        flexShrink: 0,
                                        width: "15px", // Increase the width of the checkbox
                                        height: "15px", // Adjust the height of the checkbox as needed
                                      }}
                                    />
                                    <span
                                      onClick={() => handleDownloadQRCode(item)}
                                      style={{ wordBreak: "break-word" }}
                                    >
                                      View
                                    </span>
                                  </span>
                                ) : // Add navigation links if search is true
                                  search ? (
                                    <a
                                      // Assuming the href should point to some identifier related to the data
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "blue", // Apply blue color for navigation links
                                      }}
                                      onClick={() =>
                                        handleTSSCTPTT(item.zoneId, item.circleId)
                                      }
                                    >
                                      {item[header]}
                                    </a>
                                  ) : (
                                    item[header]
                                  )}
                            </td>
                          )
                        )
                      )}
                      {headers.includes("points") ||
                        headers.includes(t("actions")) ||
                        headers.includes(t("TS/SCTP")) ||
                        headers.includes(t("total")) ? (
                        <td
                          style={{
                            border: "1px solid #FFFFFF",
                            textAlign: "center",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            backgroundColor:
                              isProd
                                ? index % 2 === 0
                                  ? "#8fc9ff"
                                  : "#aed8ff"
                                : index % 2 === 0
                                  ? "#F8CCCD"
                                  : "rgb(255 237 238)",
                          }}
                        >
                          {headers.includes("points") && (
                            <Tooltip title="View" placement="top">
                              <button
                                className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"} ${isProd ? "edit-ghmc" : "edit-swm"}`}
                                onClick={() =>
                                  viewData(item.id || item.route_id)
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                            </Tooltip>
                          )}
                          {headers.includes(t("actions")) && (
                            <>
                              {/* {canEdit && ( */}
                              <Tooltip title="Edit" placement="top">
                                <button
                                  className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"} ${isProd ? "edit-ghmc" : "edit-swm"}`}
                                  onClick={() => handleEdit(item)}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                              </Tooltip>
                              {/* )} */}
                              {/* <Tooltip title="View" placement="top">
                    <button
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F8CCCD" : "#ddefff",
                        marginRight: "5px",
                        borderRadius: "4px",
                        border: "1px solid #EC1117",
                        color: "#EC1117",
                      }}
                      onClick={() =>
                        viewData(item.id || item.zone_id)
                      }
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </Tooltip> */}
                            </>
                          )}
                          {headers.includes("total") && (
                            <td
                              style={{
                                border: "none",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              {calculateRowTotal(item)}
                            </td>
                          )}
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                    {item.additionalData &&
                      Array.isArray(item.additionalData) && (
                        <tr>
                          <td>
                            <ul>
                              {item.deployment_location_id.map((location) => (
                                <li key={location.id}>
                                  {location.location_name}
                                </li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="16" style={{ textAlign: "center" }}>
                    {t("No data available")}
                  </td>
                </tr>
              )}
              {downloadQRCode &&
                (selectedVehicleUUID || selectedContainerUUID || selectedLoadingEquipmentUUID) &&
                selectedRowData && (
                  <div style={{ display: "none" }}>
                    <div
                      id="qrCode"
                      style={{ margin: "5px auto", padding: "5px", background: "#fff" }}
                      dangerouslySetInnerHTML={{ __html: generateQRCodeSVG(selectedVehicleUUID) }}
                    />
                    <p>{selectedRowData.vehicle_number}</p>
                    {/* Display other vehicle details here */}
                    <p>Vehicle Type: {selectedRowData.vehicle_type}</p>
                    <p>Manufacturer: {selectedRowData.manufacturer}</p>
                    {/* Add other details as needed */}
                  </div>
                )}
              <Modal
                show={showMapModal}
                onHide={() => setShowMapModal(false)}
                size="lg"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <LoadScript googleMapsApiKey="YOUR_API_KEY/*  */_HERE">
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "400px" }}
                      zoom={10}
                      center={selectedLocation}
                    >
                      <Marker position={selectedLocation} />
                    </GoogleMap>
                  </LoadScript>
                </Modal.Body>
              </Modal>
            </tbody>
            {footerCount && (
              <tfoot>
                <tr
                  style={{
                    lineHeight: "14.51px",
                  }}
                >
                  <td
                    style={{
                      backgroundColor: "#443D3D",
                      color: "#FFFFFF",
                      fontWeight: "400",
                      paddingLeft: "25px",
                    }}
                  >
                    Total
                  </td>
                  {headers.map((header) => (
                    <td
                      key={header}
                      style={{
                        fontWeight: "400",
                        backgroundColor: "#443D3D",
                        color: "#fff",
                        textAlign: "left",
                        paddingLeft: "25px",
                      }}
                    >
                      {/* {totals[header]} */}
                      {typeof totals[header] === "number"
                        ? totals[header].toFixed(2)
                        : totals[header]}
                    </td>
                  ))}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
        {/* <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            padding: "8px",
          }}
        >
          <span>
            Page {currentPage} of {totalPagesCount}
          </span>
          <button
            style={{
              backgroundColor: isProd ? "#0d5da5" : "#EC1117",
              color: "#fff",
              borderRadius: "4px",
              border: "none",
              padding: "8px 12px",
              marginLeft: "20px",
              marginRight: "20px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            style={{
              backgroundColor:  isProd ? "#0d5da5" : "#EC1117",
              color: "#fff",
              borderRadius: "4px",
              border: "none",
              padding: "8px 12px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPagesCount}
          >
            Next
          </button>
        </div> */}
        {DataFetchURL.length >= rowsPerPage && <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Centering the pagination
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            style={{
              backgroundColor: "#f0f0f0",
              color: "#000",
              borderRadius: "4px",
              border: "1px solid #ccc",
              padding: "8px 12px",
              marginRight: "5px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            First
          </button>

          <button
            style={{
              backgroundColor: "#f0f0f0",
              color: "#000",
              borderRadius: "4px",
              border: "1px solid #ccc",
              padding: "8px 12px",
              marginRight: "5px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {generatePageNumbers().map((pageNumber) => (
            <button
              key={pageNumber}
              style={{
                backgroundColor: pageNumber === currentPage ? (isProd ? "#0d5da5" : "#EC1117") : "#f0f0f0",
                color: pageNumber === currentPage ? "#fff" : "#000",
                borderRadius: "4px",
                border: "1px solid #ccc",
                padding: "8px 12px",
                marginLeft: "5px",
                cursor: "pointer",
              }}
              onClick={() => handlePageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}

          <button
            style={{
              backgroundColor: "#f0f0f0",
              color: "#000",
              borderRadius: "4px",
              border: "1px solid #ccc",
              padding: "8px 12px",
              marginLeft: "5px",
              cursor: currentPage === totalPagesCount ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPagesCount}
          >
            Next
          </button>

          <button
            style={{
              backgroundColor: "#f0f0f0",
              color: "#000",
              borderRadius: "4px",
              border: "1px solid #ccc",
              padding: "8px 12px",
              marginLeft: "5px",
              cursor: currentPage === totalPagesCount ? "not-allowed" : "pointer",
            }}
            onClick={() => handlePageChange(totalPagesCount)}
            disabled={currentPage === totalPagesCount}
          >
            Last
          </button>
        </div>}
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Render the QR code */}
          {qrData && qrData ? (
            <div
              id="qrCode"
              // style={{ margin: "5px auto", padding: "5px", background: "#fff" }}
              dangerouslySetInnerHTML={{ __html: generateQRCodeSVG(qrData) }}
            />
          ) : null}
          <h4
            className="mt-4"
            style={{ fontWeight: "500", color: "blue", cursor: "pointer" }}
            onClick={downloadQRCodeImage}
          // onClick={handleDownload}
          >
            Download
          </h4>
        </Modal.Body>
      </Modal>
      {/* Modal for showing full image */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton style={{ marginTop: '5px' }}>
          <Modal.Title>Image Full Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Full vehicle" style={{ width: '100%', height: '400px', borderRadius: '5px', objectFit:"contain" }} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default withTranslation()(TableComponent);
